export default __webpack_public_path__ + "static/media/logo_yapp.f860d0c5.svg";